import { createFileRoute } from '@tanstack/react-router';

import { ClientAssessmentTakeScreen } from '@/features/assessments/components/client/ClientAssessmentTakeScreen';

export const Route = createFileRoute('/client/assessments/$assessmentId/$assignmentId/')({
  component: ClientAssessmentTakeRoute,
});

function ClientAssessmentTakeRoute() {
  const { assessmentId, assignmentId } = Route.useParams();
  return <ClientAssessmentTakeScreen assessmentId={assessmentId} assignmentId={assignmentId} />;
}
